import dayjs, {Dayjs} from 'dayjs';
import {getStrings} from '../lang';
import strings from '../../lang/locale.strings.yaml';

const S = getStrings<LocaleStrings>(strings);
export default function (option: any, dayjsClass: Function, dayjsFactory: Function): void {
    dayjsClass.prototype.getDuration = function (date: Dayjs) {
        const diff: Dayjs = date ? dayjs.utc(this.diff(date)) : this;
        const days: number = diff.date() - 1;
        let duration: string = '';
        if (days > 0) {
            duration += `${days} ${S.daysShort} `;
        }
        if (diff.hour()) {
            duration += `${Number(diff.format('HH'))} ${S.hoursShort} `;
        }
        if (diff.minute()) {
            duration += `${Number(diff.format('mm'))} ${S.minutesShort}`;
        }
        return duration.length ? duration.trim() : `0 ${S.minutesShort}`;
    };

    dayjsClass.prototype.getHours = function (date?: Dayjs): number {
        const diff: Dayjs = date ? dayjs.utc(this.diff(date)) : this;
        let days: number = parseInt(diff.format('D')) - 1;
        let hours: number = parseInt(diff.format('HH'));
        if (days > 0) {
            hours += days * 24;
        }
        return hours;
    };
    dayjsClass.prototype.getDurationShort = function (date?: Dayjs): string {
        const diff: Dayjs = date ? dayjs.utc(this.diff(date)) : this;
        let days: number = parseInt(diff.format('D')) - 1;
        let hours: number = parseInt(diff.format('HH'));
        let minutes: number = parseInt(diff.format('mm'));
        if (days > 0) {
            hours += days * 24;
        }
        return `${hours}${S.hoursShort} ${minutes}${S.minutesShort}`;
    };
    dayjsClass.prototype.getDurationTime = function (date?: Dayjs): string {
        const diff: Dayjs = date ? dayjs.utc(this.diff(date)) : this;
        let days: number = parseInt(diff.format('D')) - 1;
        let hours: number = parseInt(diff.format('HH'));
        let minutes: number = parseInt(diff.format('mm'));
        let duration: string = '';
        if (days > 0) {
            duration += `${days}:`;
        }
        // if (hours) {
        duration += `${hours}:`;
        // }
        // if (minutes) {
        duration += `${minutes}`;
        // }
        return duration;
    };
    dayjsClass.prototype.getDateStr = function (): string {
        return this.format('L');
    };
    dayjsClass.prototype.getTimeStr = function (): string {
        return this.format('HH:mm:ss');
    };
    dayjsClass.prototype.getDayjsStr = function (): string {
        return this.format('L HH:mm');
    };
    dayjsClass.prototype.getShortTimeStr = function (): string {
        return this.format('HH:mm');
    };
    dayjsClass.prototype.getTimeArray = function (): string[] {
        return [this.format('HH'), this.format('mm')];
    };
    dayjsClass.prototype.clearTime = function (): Dayjs {
        return this.startOf('day');
    };
    dayjsClass.prototype.setTimeStr = function (time: string): Dayjs {
        let t: Dayjs = dayjs.utc(time, 'HH:mm:ss');
        this.set('hour', t.hour()).set('minute', t.minute()).set('second', t.second());
        return this;
    };
    dayjsClass.prototype.getSign = function (): number {
        return this.valueOf() > 0 ? 1 : -1;
    };
    dayjsClass.prototype.getDateTimeStr = function (): string {
        return this.format('L HH:mm');
    };
    dayjsClass.prototype.getShortTimeStr = function (): string {
        return this.format('HH:mm');
    };
    dayjsClass.prototype.getDayOfWeek = function (): string {
        const weekDayNumber = this.day();
        // todo if sunday is not first?
        return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][weekDayNumber];
    };
    dayjsClass.prototype.daysCount = function (): number {
        return Math.ceil(this.startOf('day') / 86400000);
    };
}

declare module 'dayjs' {
    interface Dayjs {
        getDuration(date?: Dayjs): string;
        getHours(date?: Dayjs): number;
        getDurationShort(date?: Dayjs): string;
        getDurationTime(date?: Dayjs): string;
        getDateStr(): string;
        getTimeStr(): string;
        getDayjsStr(): string;
        getShortTimeStr(): string;
        getTimeArray(): string[];
        clearTime(): Dayjs;
        setTimeStr(time: string): Dayjs;
        getDateTimeStr(): string;
        getShortTimeStr(): string;
        getSign(): number;
        getDayOfWeek(): string;
        daysCount(): number;
    }
}
